export default {
    lang: function () {
        const langBrowser = navigator.language;
        if (langBrowser.split('-')[0] === 'es') {
            return 'es';
        } else {
            return 'en';
        }
    }
}